"use strict";
// if you're updating this please also update PropertyInputExpandableText which is going to replace this soon
// see https://git.hubteam.com/HubSpot/CRM-Issues/issues/4221 for more context
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _UIExpandableText = _interopRequireDefault(require("UIComponents/text/UIExpandableText"));

var _UIExpandingTextArea = _interopRequireDefault(require("UIComponents/input/UIExpandingTextArea"));

var _omit = _interopRequireDefault(require("transmute/omit"));

var _immutable = require("immutable");

var propTypes = _UIExpandingTextArea.default.propTypes;

var PropertyInputTextArea =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputTextArea, _React$Component);

  function PropertyInputTextArea() {
    (0, _classCallCheck2.default)(this, PropertyInputTextArea);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputTextArea).apply(this, arguments));
  }

  (0, _createClass2.default)(PropertyInputTextArea, [{
    key: "focus",
    value: function focus() {
      this.refs.input.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var transferableProps = (0, _omit.default)(['baseUrl', 'caretRenderer', 'isInline', 'getProperty', 'multiCurrencyCurrencyCode', 'objectType', 'onCancel', 'onInvalidProperty', 'propertyIndex', 'propertyInputComponentConfig', 'readOnlySourceData', 'resolver', 'showError', 'showPlaceholder', 'subject', 'subjectId', 'secondaryChanges', 'onSecondaryChange', 'wrappers', 'onTracking', 'isRequired', 'property'], (0, _immutable.Seq)(this.props)).toJS();
      return _react.default.createElement(_UIExpandableText.default, {
        buttonAlign: "left",
        hideButtonCaret: true
      }, _react.default.createElement(_UIExpandingTextArea.default, (0, _extends2.default)({}, transferableProps, {
        ref: "input",
        shrink: true
      })));
    }
  }]);
  return PropertyInputTextArea;
}(_react.default.Component);

exports.default = PropertyInputTextArea;
PropertyInputTextArea.propTypes = propTypes;
PropertyInputTextArea.defaultProps = _UIExpandingTextArea.default.defaultProps;
module.exports = exports.default;